import { Link } from "@fluentui/react";
import { IColumn } from "@fluentui/react/lib/DetailsList";

import ListingsLayout from "components/shared/ListingsLayout";
import customTheme from "helpers/customTheme";
import {
  getRevisionStatusDisplayName,
  getRevisionStatusStyle,
} from "helpers/revisions";
import { useTrackingContext } from "components/shared/TrackingContext";
import { RouteComponent, routeDefinitions } from "router";
import { useGetAllPoliciesQuery } from "services/policy";
import stringsConst from "consts/strings";
import usePolicyPanel from "hooks/policy/usePolicyPanel";
import useRouter from "hooks/useRouter";
import { environmentConfig } from "config/environmentConfig";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PolicyEditState } from "models/policyPanel";
// eslint-disable-next-line import/no-named-as-default
import PolicyInfo from "./PolicyInfo";

const LinkStyles = {
  color: customTheme.bodyColor,
};

// Create a wrapper hook that passes parameters
const useGetAllPoliciesWithParams: typeof useGetAllPoliciesQuery = (args?: any) =>
  useGetAllPoliciesQuery({
    cloud: environmentConfig.cloud,
    environment: environmentConfig.environment,
    policyType: "ImplicitAcceptance",
    ...args,
  });

// eslint-disable-next-line react/function-component-definition
const Policies = () => {
  const { trackEvent } = useTrackingContext();
  const { openPanel: openPolicyPanel } = usePolicyPanel(); // Used in addNew callback
  const { goToRoute } = useRouter();

  const listingColumns: IColumn[] = [
    {
      key: stringsConst.common.listings.nameKey,
      name: "Policy Name",
      fieldName: stringsConst.common.listings.nameKey,
      minWidth: 35,
      isResizable: true,
      // eslint-disable-next-line react/no-unstable-nested-components
      onRender: (item: any) => (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          title={item.name}
          key={item.key}
          style={LinkStyles}
          onClick={() => {
            goToRoute(
              routeDefinitions.PolicyEdit.getRouteInfo({
                policyId: item.objectIdInfo.policyId,
              })
            );
            trackEvent("View policy details");
          }}
        >
          {item.name}
        </Link>
      ),
    },
    {
      key: stringsConst.common.listings.descriptionKey,
      name: stringsConst.common.listings.descriptionValue,
      fieldName: stringsConst.common.listings.descriptionKey,
      minWidth: 250,
      isResizable: true,
    },
    {
      key: "template",
      name: "Template",
      fieldName: "template",
      minWidth: 175,
      isResizable: true,
    },
    {
      key: stringsConst.common.listings.statusKey,
      name: stringsConst.common.listings.statusValue,
      fieldName: stringsConst.common.listings.statusKey,
      minWidth: 80,
      maxWidth: 100,
      // eslint-disable-next-line react/no-unstable-nested-components
      onRender: (item: any) => (
        <span style={getRevisionStatusStyle(item.status, item?.isTestPolicy || false)}>
          {getRevisionStatusDisplayName(item.status, item?.isTestPolicy || false)}
        </span>
      ),
    },
  ];

  return (
    <ListingsLayout
      listingColumns={listingColumns}
      type={RouteComponent.Policies}
      useGetAllQuery={useGetAllPoliciesWithParams as any}
      InfoComponent={PolicyInfo}
      addNew={() => {
        openPolicyPanel(undefined, PolicyEditState.NewPolicy); // Open panel in creation mode
        trackEvent("Add new policy");
      }}
      searchBoxWidth="250px"
    />
  );
};

export default Policies;